<!--
 * @Author: awu
 * @Date: 2020-12-08 20:32:36
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 22:29:31
 * @Description: 展台海报
-->
<template>
    <div :class="scale ? 'hb-scale' : 'hb'">
        <div class="scale" :style="scale ? {color: '#fff'} : {color: '#09468c'}" @click="toggleScale">
            <img :src="scaleBtn" alt="" />
        </div>
        <div class="backHome" @click="backHome">
            <img :src="closeBtn" alt="" />
        </div>
        <swiper :class="scale ? 'swiper-scale' : 'swiper'" ref="mySwiper" :options="swiperOptions">
            <swiper-slide
                v-for="(item,index) in swiperSlide"
                :key="index"
            >
                <div class="box">
                    <img :src="item.resource.download_url" alt="">
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" @click="prev()" slot="button-prev">
            <img v-show="leftArrowFlag" src="@/assets/left.png" alt="" />
            <img v-show="!leftArrowFlag" src="@/assets/noLeft.png" alt="" />
        </div>
        <div class="swiper-button-next" @click="next()" slot="button-next">
            <img v-show="rightArrowFlag" src="@/assets/right.png" alt="" />
            <img v-show="!rightArrowFlag" src="@/assets/noRight.png" alt="" />
        </div>
    </div>
</template>

<script>
import api from "@/api";
import { exhibition_id } from "@/utils/exhibitId";
import Shade from "@/components/shade"
export default {
    name: "Hb",
    components:{
        Shade
    },
    data() {
        return {
            swiperOptions: {
                //设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    disabledClass: "my-button-disabled"
                },
                loop: false,
                slidesPerView: 1,
                lidesPerGroup: 1
            },
            slideNum:1,
            leftArrowFlag: false,
            rightArrowFlag: false,
            swiperSlide: [],
            instance_id: null,
            scale: false,
            scaleSmallImg: require('@/assets/user/scale.png'),
            scaleBigImg: require('@/assets/user/scaleBig.png'),
            closeWhite: require('@/assets/user/closeWhite.png'),
            close: require('@/assets/user/close.png')
        };
    },
    mounted() {
        this.instance_id = Number(this.$route.query.instance_id);
        this.getExhibitionVideo();
    },
    methods: {
        toggleScale() {
          this.scale = !this.scale;
        },
        backHome() {
            this.$emit("cancel", 8);
        },
        getExhibitionVideo() {
            api.getExhibitionVideo({
                exhibition_id: exhibition_id,
                instance_id: this.instance_id,
                type: "image"
            }).then((res) => {
                console.log('海报列表',res)
                this.swiperSlide = res.list;

            });
        },
        prev() {
            this.swiper.slidePrev();
            this.slideNum--;
            if (this.slideNum <= 1) {
                this.slideNum = 1;
            }
        },
        next() {
            this.swiper.slideNext();
            this.slideNum++;
            if (this.slideNum >= this.swiperSlide.length) {
                this.slideNum = this.swiperSlide.length;
            }
        },
    },
    watch: {
        slideNum(value) {
            if (value <= 1) {
                this.leftArrowFlag = false;
            }
            this.leftArrowFlag = value <= 1 ? false : true;
            this.rightArrowFlag = value >= this.swiperSlide.length ? false : true;
        },
        swiperSlide(value) {
            if (value.length <= 1) {
                this.leftArrowFlag = false;
                this.rightArrowFlag = false;
            } else {
                this.leftArrowFlag = false;
                this.rightArrowFlag = true;
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        },
        closeBtn() {
            return this.scale ? this.closeWhite : this.close
        },
        scaleBtn() {
          return this.scale ? this.scaleBigImg : this.scaleSmallImg
        }
    }
};
</script>

<style lang="scss" scoped>
.hb-scale {
  position: fixed;
  z-index: 100000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(1, 1, 1, 0.7);
  border-radius: 0;
}
.hb {
    position: fixed;
    z-index: 5;
    width: 667px;
    height: 547px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 20px;
}
.swiper-scale {
  width: 1000px;
  height: 800px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .box{
    width: 100%;
    height: 100%;
    overflow: auto;
    >img{
      width: 100%;
      height: auto;
    }
  }
}
.swiper {
  width: 385px;
  height: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .box{
    width: 100%;
    height: 100%;
    >img{
      width: 100%;
      height: 100%;
    }
  }
}
.shade{
  width: 100vw;
  height: 100vh;
  background-color: red;
  position: fixed;
  top: 0;
  left: 0;
}
.backHome {
  width: 33px;
  height: 33px;
  position: absolute;
  top: 21px;
  right: 21px;
  cursor: pointer;
  border-radius: 50%;
  > img {
    width: 100%;
    height: 100%;
  }
}
.scale {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 22px;
  right: 65px;
  width: 33px;
  height: 33px;
  cursor: pointer;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 600;
  > img {
    width: 20px;
    height: 20px;
  }
}
.backHome:hover, .scale:hover {
   background-color: #e8eef4;
 }
</style>



// WEBPACK FOOTER //
// src/views/area/components/hb.vue